/*
 * @Author: Teemo Ding
 * @Date: 2022-03-03 17:13:42
 * @LastEditTime: 2022-06-07 13:49:31
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Template/CommonTemplate/index.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import { Form } from 'antd';
import { get } from 'lodash';
import React, { Fragment } from 'react';
//import PickUpTime from 'src/pages/Settings/Logistics/PickupLocations/Components/PickUpTime';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
//import GeneralInformation from '../../Components/GeneralInformation';
//import { TableForm } from 'src/components/EditableTable/TableForm/TableForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { useTemplates } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Template/tools';
import { i18nGet } from 'src/tools/tools';
import TemplateTable from '../../Components/TemplateTable';
import css from '../../css.module.less';

const CommonTemplate = ({
  dataIndex,
  templates: t,
  onSendTest,
  title,
  channelType,
  category,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const templates = useTemplates({ category, templates: t, channelType });

  const templatesOptions = templates.map((item) => ({
    ...item,
    label: (
      <div className={css.templates}>
        <h3> {item.name}</h3>
        <span> {item.communicationGatewayName}</span> |{' '}
        <span> {item.communicationGatewayRemarks}</span>
      </div>
    ),
  }));

  // console.log(channelType, templates, templatesOptions);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={`${title} ${getI18n('salesChannelCommunication.index.template')}`}>
      <Form.Item
        name={['channelSettings', dataIndex, 'enabled']}
        valuePropName='checked'>
        <Checkbox>
          {`${getI18n(
            'salesChannelCommunication.index.enable',
          )} ${title} ${getI18n(
            'salesChannelCommunication.index.notification',
          )}`}
        </Checkbox>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          ((prevValues.channelSettings || [])[dataIndex] || {}).enabled !==
          ((currentValues.channelSettings || [])[dataIndex] || {}).enabled
        }>
        {({ getFieldValue }) =>
          getFieldValue(['channelSettings', dataIndex, 'enabled']) && (
            <Fragment>
              <Form.Item
                labelCol={{ span: 24 }}
                label={`${title} ${getI18n(
                  'salesChannelCommunication.index.template',
                )}`}
                name={['channelSettings', dataIndex, 'templateUuid']}>
                <SelectObjectAsValue
                  className={css.select}
                  showSearch
                  objectAsValue
                  size='large'
                  getPopupContainer={(trigger) => trigger}
                  valueKey='uuid'
                  // labelKey='name'
                  options={templatesOptions || []}
                  filterOption={(input, option) => {
                    const indexOption = templates.filter(
                      (o) => o.uuid === option.value,
                    );
                    return (
                      get(indexOption, [0, 'name'])
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                />
              </Form.Item>

              <Form.Item
                shouldUpdate={(prevValues, currentValues) =>
                  ((prevValues.channelSettings || [])[dataIndex] || {})
                    .templateUuid !==
                  ((currentValues.channelSettings || [])[dataIndex] || {})
                    .templateUuid
                }>
                {({ getFieldValue }) => (
                  <TemplateTable
                    id='templateInformation'
                    channelType={channelType}
                    dataSource={
                      (
                        getFieldValue([
                          'channelSettings',
                          dataIndex,
                          'templateUuid',
                        ]) || {}
                      ).availableLanguages || []
                    }
                    onSendTest={(languageTag) =>
                      onSendTest(
                        languageTag,
                        (
                          getFieldValue([
                            'channelSettings',
                            dataIndex,
                            'templateUuid',
                          ]) || {}
                        ).uuid || '',
                      )
                    }
                    defaultLanguageName={[
                      'channelSettings',
                      dataIndex,
                      'defaultLanguage',
                    ]}
                  />
                )}
              </Form.Item>
            </Fragment>
          )
        }
      </Form.Item>
    </SectionWrapper>
  );
};

export default CommonTemplate;
